import React from "react";
import "./custom-toast.css";
import { Toast, ToastContainer } from "react-bootstrap";
import { useAppSelector } from "../../store/storeRequests";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";

const CustomToast: React.FunctionComponent<any> = () => {
  const { position, visible, message, title } = useAppSelector(
    StoreSelectors.TOAST_STATE
  );
  

  return (
    <ToastContainer
      className="p-3 mf-toaster"
      position={position}
      style={{ zIndex: 1200 }}
    >
      <Toast show={visible} className="mf-toaster-container">
        {title.length !== 0 && (
          <Toast.Header closeButton={false} className="mf-toaster-header">
            <strong className="me-auto weight-600 font-18">{title}</strong>
          </Toast.Header>
        )}
        <Toast.Body className="mf-toaster-container mf-toaster-body text-white font-14 weight-500 text-center">
          {message}
        </Toast.Body>
      </Toast>
      
    </ToastContainer>

    
  );
};

export default CustomToast;
